{
  "weeks": [
    {
      "weekStart": "2026-09-22",
      "weekEnd": "2026-09-28",
      "updatedAt": "2026-09-26T17:12:00Z",
      "items": [
        {
          "title": "Undo restores moves, deletes, tags, and properties",
          "summary": "Five undo bugs found by property-based testing now round-trip correctly, with regression coverage in the worker suite.",
          "link": "https://github.com/logseq/logseq/pull/13444",
          "priority": 1
        },
        {
          "title": "Safer paste of page refs and embeds",
          "summary": "Deduped pasted page refs that exploded into thousands of pages, bounded the batch-delete dialog, and fixed drag/paste of page embeds.",
          "link": "https://github.com/logseq/logseq/pull/13436",
          "priority": 2
        },
        {
          "title": "Editor composition and focus fixes",
          "summary": "Dead-key layouts no longer double characters, escape-editing clears only its own block, and the editor flushes before ref navigation.",
          "link": "https://github.com/logseq/logseq/pull/13443",
          "priority": 3
        },
        {
          "title": "Query builder and /query hardening",
          "summary": "Incomplete /query syntax no longer crashes the app; property chips show titles, custom status/priority appear in filters, and class defaults stay scoped.",
          "link": "https://github.com/logseq/logseq/pull/13419",
          "priority": 4
        },
        {
          "title": "Sync and checksum reliability",
          "summary": "Value replacements stay in one request, stale local checksums heal on graph open, and outliner insert identities survive sync replay.",
          "link": "https://github.com/logseq/logseq/pull/13432",
          "priority": 5
        },
        {
          "title": "Tag pages and views feel snappier",
          "summary": "Tag page bodies mount after the objects table paints, small class tables sort without a row-limit walk, and block render watches are indexed.",
          "link": "https://github.com/logseq/logseq/pull/13435",
          "priority": 6
        },
        {
          "title": "CLI markdown block upsert",
          "summary": "Upsert blocks accept Markdown via --blocks/--blocks-file, with clearer skill docs and healthier worker retirement during CLI runs.",
          "link": "https://github.com/logseq/logseq/pull/13377",
          "priority": 7
        },
        {
          "title": "Flashcards empty state and due count",
          "summary": "When no cards are due, practice-again is offered instead of the create-card empty state, and the due counter refreshes after rating.",
          "link": "https://github.com/logseq/logseq/pull/13410",
          "priority": 8
        },
        {
          "title": "Repeating dates and page updated-at",
          "summary": "Date repeats stay on the correct calendar day west of UTC, clearing datetimes drops stale journal refs, and page updated-at bumps on insert/move/delete.",
          "link": "https://github.com/logseq/logseq/pull/13433",
          "priority": 9
        },
        {
          "title": "Library moves and browser MCP",
          "summary": "Only normal pages move into Library with correct namespace roots, and Electron /mcp works from browser-based MCP clients.",
          "link": "https://github.com/logseq/logseq/pull/13397",
          "priority": 10
        }
      ]
    },
    {
      "weekStart": "2026-09-15",
      "weekEnd": "2026-09-21",
      "updatedAt": "2026-09-22T15:30:00Z",
      "items": [
        {
          "title": "Faster DB graph scans",
          "summary": "Cut several O(graph) paths in views, journals, refs, and startup revision checks so larger graphs stay responsive.",
          "link": "https://github.com/logseq/logseq/pull/13347",
          "priority": 1
        },
        {
          "title": "Snappier block editing",
          "summary": "Stopped re-rendering the editor box on every keystroke and sized the textarea with CSS field-sizing where supported.",
          "link": "https://github.com/logseq/logseq/pull/13211",
          "priority": 2
        },
        {
          "title": "More reliable DB worker",
          "summary": "Moved lock ownership to SQLite and keep the worker healthy across system sleep so graphs do not get stuck after idle.",
          "link": "https://github.com/logseq/logseq/pull/13302",
          "priority": 3
        },
        {
          "title": "Library and sidebar polish",
          "summary": "Hide library blocks, collapse nested pages more cleanly, and refresh favorites after drag-and-drop reorder.",
          "link": "https://github.com/logseq/logseq/pull/13349",
          "priority": 4
        },
        {
          "title": "Property paste and undo fixes",
          "summary": "Copy and paste text property values as blocks, restore property values after undo, and keep child page content on selection delete.",
          "link": "https://github.com/logseq/logseq/pull/13324",
          "priority": 5
        },
        {
          "title": "Query and table view fixes",
          "summary": "Fixed query result views and set-literal editing, restored property columns, and sped up DB table scrolling.",
          "link": "https://github.com/logseq/logseq/pull/13318",
          "priority": 6
        },
        {
          "title": "CLI and Windows build fixes",
          "summary": "Added force-remove page, username/password login, and fixed Windows vite/bundle and state-phase build issues.",
          "link": "https://github.com/logseq/logseq/pull/13331",
          "priority": 7
        },
        {
          "title": "Import and publishing fixes",
          "summary": "Convert markdown headings into DB heading metadata on import, and honor default home in HTML export.",
          "link": "https://github.com/logseq/logseq/pull/13275",
          "priority": 8
        }
      ]
    },
    {
      "weekStart": "2026-09-08",
      "weekEnd": "2026-09-14",
      "updatedAt": "2026-09-22T15:30:00Z",
      "items": [
        {
          "title": "Faster file-graph import",
          "summary": "Optimized the file graph import path and preserved mention timestamps, icons, and PDF annotations more reliably.",
          "link": "https://github.com/logseq/logseq/pull/13130",
          "priority": 1
        },
        {
          "title": "Page rename and delete edge cases",
          "summary": "Update linking page mirrors on rename, tag Recycle as Page so File\u2192DB deletes work, and load breadcrumbs on demand.",
          "link": "https://github.com/logseq/logseq/pull/13147",
          "priority": 2
        },
        {
          "title": "Property and shortcut polish",
          "summary": "URL property editor UX, default Task status icons, shared default shortcuts when resetting, and Contents from the right-sidebar menu.",
          "link": "https://github.com/logseq/logseq/pull/13186",
          "priority": 3
        }
      ]
    }
  ]
}
